import { graphql } from "gql";

const EDIT_ME_USER_PREFERENCE_MUTATION = graphql(`
  mutation EditMeUserPreference($name: String!, $value: String) {
    editMe(input: { userPreferenceList: [{ name: $name, value: $value }] }) {
      id
      userPreferenceList {
        id
        userId
        name
        value
      }
    }
  }
`);

export default EDIT_ME_USER_PREFERENCE_MUTATION;
